import { useQuery } from '@tanstack/react-query';
import { getRecommendations } from '../../../services';
import { IBookingEvent, IMentor, Recommendations } from '../../../types';
import useGetMentors from './use-get-mentors';
import useGetOfferings from './use-get-offerings';

const get2Recommendations = (data: Array<IMentor | IBookingEvent>) =>
  data?.filter(({ isRecommended }: any) => isRecommended).slice(0, 2);

const useGetEvents = () => {
  const mentors = useGetMentors();
  const offerings = useGetOfferings();
  const recommendations = useQuery<Recommendations>(
    ['recommendations'],
    getRecommendations,
  );

  const oneOnOne =
    mentors?.data?.map((mentor: IMentor) => ({
      ...mentor,
      isRecommended: recommendations?.data?.allRecommendations.MENTOR.includes(
        mentor.id as any,
      ),
    })) ?? [];

  const communitySessions =
    offerings?.data?.map((offering: IBookingEvent) => ({
      ...offering,
      isRecommended: recommendations?.data?.allRecommendations.COMMUNITY_SESSION.includes(
        offering.id as any,
      ),
    })) ?? [];

  const recommendationType = recommendations?.data?.type;

  const recommendationBox =
    recommendationType === 'MENTOR'
      ? get2Recommendations(oneOnOne)
      : get2Recommendations(communitySessions);

  return {
    oneOnOne,
    communitySessions,
    recommendationBox,
    recommendationType,
    recommendationId: recommendations?.data?.id,
    isLoading:
      mentors?.isLoading || offerings?.isLoading || recommendations?.isLoading,
    isError: mentors?.isError || offerings?.isError || recommendations?.isError,
    isSuccess:
      mentors?.isSuccess || offerings?.isSuccess || recommendations?.isSuccess,
  };
};

export default useGetEvents;
